export const SURVEY_PAGES = {
    SurveyPage: '/survey',
    EngagementSurvey: '/engagementSurvey',
    WLSurveyPage: '/wlsurvey'
}

export const SURVEY_ENDPOINT = 
{
    Survey: 'survey',
    GetEngagementSurveyQuestions: 'survey/GetSingleSurveyQuestions',
    PostEngagementSurvey: 'survey/PostSingleSurvey',
    GetWhiteListData: 'survey/GetWhiteListData'
}

export const LastYearData = 'Last 12 Months ';